module.exports = __webpack_public_path__ + "static/img/5.336ab01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/5.png
// module id = WOoC
// module chunks = 0